module.exports = __webpack_public_path__ + "img/cosmob.886f43ef.png";